<template>
  <div class="import-consumption-record-container basicStyle">
    <el-form
      :inline="true"
      :model="detailFormData"
      class="demo-form-inline querySearch"
    >
      <el-form-item label="任务名称:">
        <el-select v-model="detailFormData.taskName" placeholder="请选择">
          <el-option
            v-for="item in taskNameData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="导入状态">
        <el-select v-model="detailFormData.importStatus" placeholder="请选择">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <MyButton
        v-if="role == 'admin' || role == 'generaladministrato'"
        value="导出Excel"
        size="medium"
        type="1"
        @click="downloadExcel"
      ></MyButton>
    </el-form>
    <!-- infoDetailData 信息详情数据 -->
    <el-table
      :data="infoDetailData"
      style="width: 100%"
      border
      :row-class-name="addFailClass"
    >
      <el-table-column
        prop="fullname"
        label="姓名"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="score"
        label="分数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="app_type_names"
        label="考试名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="province"
        label="省份"
        align="center"
      ></el-table-column>
      <el-table-column prop="city" label="市" align="center"></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="created_at"
        label="导入时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="status_name"
        label="导入状态"
        align="center"
      ></el-table-column>
      <!-- <el-table-column prop="status" label="导入状态" align="center">
        <template slot-scope="scope"> 
          {{ statusOptionsMap.get(scope.row.status) }}
        </template>
      </el-table-column> -->
      <el-table-column
        prop="result"
        label="导入状态说明"
        align="center"
      ></el-table-column>
    </el-table>
    <el-pagination
      class="foot-page"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 15, 20, 30]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog
      title=""
      :visible.sync="excelVisible"
      class="formDialog"
      width="600px"
    >
      <div style="text-align: center; padding: 20px 0">
        导出任务已提交，请前往
        <span style="color: #409eff; cursor: pointer" @click="excelClick"
          >数据导出中心</span
        >
        查看进度
      </div>
    </el-dialog>
  </div>
</template>

<script>
import callPhoneApi from "@/api/callphone";
import commonApi from "@/api/common";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "importDetalRecord", // 导入详情记录
  components: {
    MyButton,
  },
  created() {
    this.getMe();
    this.detailFormData.taskName = Number(this.$route.query.id);
    // this.getImportDetalRecord();
  },
  computed: {
    statusOptionsMap() {
      return new Map(
        this.statusOptions.map((item) => [item.value, item.label])
      );
    },
  },
  data() {
    return {
      // 详情表单数据
      detailFormData: {
        taskName: "",
        importStatus: 0,
      },
      // 任务名称
      taskNameData: [],
      // 状态选项
      statusOptions: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "导入成功",
        },
        {
          value: 2,
          label: "导入失败",
        },
        {
          value: 3,
          label: "重复数据",
        },
      ],
      // 信息详情数据
      infoDetailData: [],
      // 第几页数据
      currentPage: 1,
      // 每一页几条数据
      limit: 10,
      // 总数据
      total: 0,
      excelVisible: false,
      role: "",
    };
  },
  watch: {
    "detailFormData.importStatus"(newVal, oldVal) {
      this.filterFn(newVal);
    },
    "detailFormData.taskName"(newVal, oldVal) {
      this.changeTask(newVal);
    },
  },
  methods: {
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        this.role = res.data.role;
      }
    },
    excelClick() {
      // 数据导出中心
      this.$router.push({
        path: "/cardExportLog",
      });
    },
    downloadExcel() {
      this.$confirm("是否确定导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          callPhoneApi
            .getImportDetalRecord({
              limit: 10000,
              page: this.currentPage,
              status: this.detailFormData.importStatus,
              task_id: this.detailFormData.taskName,
              is_can_export: 1,
            })
            .then((res) => {
              if (res.code === 200) {
                console.log("studentsImportListDetail", res.data);
                this.excelVisible = true;
                this.$message({
                  type: "success",
                  message: res.message,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    // 监听导入状态时触发的筛选函数
    filterFn(newVal) {
      this.detailFormData.importStatus = newVal;
      // 状态改变时，回到第一页
      this.currentPage = 1;
      this.getImportDetalRecord();
    },
    // 监听任务名称改变时触发的函数
    changeTask(newVal) {
      // 任务直接获取
      this.detailFormData.taskName = newVal;
      // 任务改变时，回到第一页
      this.currentPage = 1;
      this.getImportDetalRecord();
    },
    // 改变每一页尺寸触发的函数
    handleSizeChange(val) {
      this.limit = val;
      this.currentPage = 1;
      this.getImportDetalRecord();
    },
    // 改变页面触发的函数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getImportDetalRecord();
    },
    // 添加未导入成功的样式
    addFailClass({ row }) {
      if (row.status == 2 || row.status == 3) {
        return "failClass";
      }
    },
    // 获取详情记录
    getImportDetalRecord() {
      const params = {
        limit: this.limit,
        page: this.currentPage,
        status: this.detailFormData.importStatus,
        task_id: this.detailFormData.taskName,
      };
      callPhoneApi.getImportDetalRecord(params).then((res) => {
        if (res.code === 200) {
          this.infoDetailData = res.data.data;
          this.total = res.data.total;
        }

        // 获取任务名字列表
        this.getTaskNameData();
      });
    },
    // 获取任务名字列表
    getTaskNameData() {
      callPhoneApi.getTaskNameData().then((res) => {
        if (res.code == 200) {
          this.taskNameData = [{ id: 0, name: "全部任务" }, ...res.data];
          console.log("this.taskNameData", this.taskNameData);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.import-consumption-record-container {
  .foot-page {
    margin-top: 20px;
  }
  /deep/ .failClass {
    color: rgb(192, 196, 204) !important;
  }
}
</style>
